module.exports = __webpack_public_path__ + "img/chargingport_300.43f40a2b.jpg";